export const OPEN_LOGIN_POPUP_GOOGLE = "openLoginPopupGoogle";
export const OPEN_LOGIN_POPUP_APPLE = "openLoginPopupApple";
export const LOGOUT_FROM_FIREBASE = "logoutFromFirebase";
export const SETUP = "setup";
export const SIGN_IN_WITH_EMAIL_AND_PASSWORD = "signInWithEmailAndPassword";
export const SIGN_UP_WITH_EMAIL_AND_PASSWORD = "signUpWithEmailAndPassword";
export const RELOAD_CURRENT_USER = "reloadCurrentUser";
